var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"word-break":"break-all hyphens: auto","white-space":"normal"}},[_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }